export default "__VITE_ASSET__CBC_aZY7__"